export default "__VITE_ASSET__CCrDY95w__"